export const classificationOptions = {
  EFE_INT_CARGO: {
    label: 'Cargo no afecta',
    tooltip: 'Cargo NO afecta rendimiento',
  },
  EFE_INT_ABONO: {
    label: 'Abono no afecta',
    tooltip: 'Abono NO afecta rendimiento',
  },
  EFE_EXT_CARGO: {
    label: 'Cargo afecta',
    tooltip: 'Cargo afecta rendimiento',
  },
  EFE_EXT_ABONO: {
    label: 'Abono afecta',
    tooltip: 'Abono afecta rendimiento',
  },
};

export const MONTHS = [
  'ene',
  'feb',
  'mar',
  'abr',
  'may',
  'jun',
  'jul',
  'ago',
  'sep',
  'oct',
  'nov',
  'dic',
];

export const ROWS_PER_PAGE_OPTIONS = [5, 10, 25, 50, 75, 100];

export const MENU_KEYS = {
  home: 'HOME',
  clients: 'CLIENTS',
  funds: 'FUNDS',
  portfolioRebalance: 'PORTFOLIO_REBALANCE',
  rebalanceFunds: 'FOUNDS_REBALANCE',
  reports: 'REPORTS',
  administrationManagement: 'ADMINISTRATION_MANAGEMENT',
};

export const SCREENS_KEYS = {
  dashboard: 'DASHBOARD',
  administration: 'ADMINISTRATION',
  fundsAdministration: 'FUNDS_ADMINISTRATION',
  onboarding: 'ONBOARDING',
  positions: 'POSITIONS',
  fundsPositions: 'FUNDS_POSITIONS',
  positionsPortafolio: 'POSITIONS_PORTAFOLIO',
  positionsMovements: 'POSITIONS_MOVEMENTS',
  positionsYields: 'POSITIONS_YIELDS',
  positionsFundsPortfolio: 'POSITIONS_FUNDS_PORTFOLIO',
  positionsFundsMovements: 'POSITIONS_FUNDS_MOVEMENTS',
  positionsFundsYields: 'POSITIONS_FUNDS_YIELDS',
  newClient: 'NEW_CLIENT',
  massUpload: 'MASS_UPLOAD',
  portfolio: 'PORTFOLIO',
  strategy: 'STRATEGY',
  restrictions: 'RESTRICTIONS',
  balancing: 'BALANCING',
  globalOrders: 'GLOBAL_ORDERS',
  fundsPortfolio: 'FOUNDS_PORTFOLIO',
  fundsStrategy: 'FOUNDS_STRATEGY',
  fundsRestrictions: 'FOUNDS_RESTRICTIONS',
  fundsBalancing: 'FOUNDS_BALANCING',
  fundsglobalOrders: 'FOUNDS_GLOBAL_ORDERS',
  operationReports: 'OPERATION_REPORTS',
  investment: 'INVESTMENT',
  fee: 'FEE',
  documentary: 'DOCUMENTARY',
  reportsFounds: 'REPORTS_FOUNDS',
  liquidityReport: 'LIQUIDITY_REPORT',
  compliance: 'COMPLIANCE',
  complianceOperaciones: 'COMPLIANCE_OPERACIONES',
  complianceRestringidos: 'COMPLIANCE_RESTRINGIDOS',
  complianceServices: 'COMPLIANCE-SERVICES',
  complianceAudits: 'COMPLIANCE-AUDITS',
  complianceSales: 'COMPLIANCE-SALES',
  complianceRiskAssessment: 'COMPLIANCE-RISK-ASSESSMENTV2',
  complianceUnusualOperations: 'COMPLIANCE-UNUSUAL-OPERATIONS',
  complianceRiskAssessmentEbr: 'COMPLIANCE-RISK-ASSESSMENT-EBR',
  complianceAlertLog: 'COMPLIANCE-ALERT-LOG',
  complianceOperationalReports: 'COMPLIANCE-OPERATIONAL-REPORTS',
  complianceComplaints: 'COMPLIANCE-COMPLAINTS',
  complianceOperatedAmounts: 'COMPLIANCE-OPERATED-AMOUNTS',
  complianceOperationalAlerts: 'COMPLIANCE-OPERATIONAL-ALERTS',
  operation: 'OPERATION',
  operationLoad: 'OPERATION_LOAD',
  operationEmisora: 'OPERATION_EMISORA',
  operationMovements: 'OPERATION_MOVEMENTS',
  operationHomologation: 'OPERATION_HOMOLOGATION',
  operationPrices: 'OPERATION_PRICES',
  operationFilters: 'OPERATION_FILTERS',
  operationAuditLoadValidation: 'OPERATION_AUDIT_LOAD_VALIDATION',
  configuration: 'CONFIGURATION',
  configurationUsers: 'CONFIGURATION_USERS',
  configurationRoles: 'CONFIGURATION_ROLES',
  configurationAccessUsers: 'CONFIGURATION_ACCESS_USERS',
  configurationGroups: 'CONFIGURATION_GROUPS',
  configurationProfiles: 'CONFIGURATION_PROFILES',
  configurationCompliance: 'CONFIGURATION_COMPLIANCE',
  configurationEvents: 'CONFIGURATION_EVENTS',
  configurationAppearance: 'CONFIGURATION_APPEARANCE',
  configurationCatalog: 'CONFIGURATION_CATALOG',
} as const;

export const ACTION_KEYS = {
  reportInvestmentRecalculateYields: 'REPORT_INVESTMENT_RECALCULATE_YIELDS',
  reportInvestmentReprocessYields: 'REPORT_INVESTMENT_REPROCESS_YIELDS',
  complianceSalesConfiguration: 'COMPLIANCE_SALES_CONFIGURATION',
  operationLoadDownload: 'OPERATION_LOAD_DOWNLOAD',
} as const;

export const NATIONALITY_VALUES = {
  foreign: 'E',
  national: 'N',
};

export const INIT_PAGINATION = {
  pageSize: 25,
  page: 0,
  count: 0,
};

export const ADMIN_SOURCE_TYPES = {
  CLIENTES: 'clientes',
  FONDOS: 'fondos',
  DASHBOARD: 'dashboard',
  PORTAFOLIO_MODELO: 'portafolio-modelo',
  PORTAFOLIO_FONDOS: 'portafolio-fondos',
} as const;

export const SURA_SPECIAL_INSTITUTION_ALLIANZ = '19';
export const SURA_PREFIX_INSTITUTION_ALLIANZ = 'SVIP';
